<div class="file-drop-area" [ngClass]="{ fileOver: fileOver }">
    <span (click)="fileInput.click()" class="btn btn-primary">{{
        'DOCBOX_UPLOAD_FORM_FILE_SELECT_HINT' | translate
    }}</span>
    @if (hasImageMimeType()) {
        <span (click)="openCamera()" class="btn btn-secondary ms-2">{{
            'DOCBOX_UPLOAD_FORM_FILE_CAMERA_BUTTON' | translate
        }}</span>
    }
    <span class="file-msg ms-3">{{
        file ? file.name : ('DOCBOX_UPLOAD_FORM_FILE_SELECT_FILENAME_ALT' | translate)
    }}</span>
    @if (thumbnail !== undefined) {
        <img
            class="thumbnail mt-1"
            [alt]="'DOCBOX_UPLOAD_FORM_FILE_SELECT_THUMBNAIL_ALT' | translate"
            [src]="thumbnail"
        />
    }
    <br />
    @if (thumbnail === undefined) {
        <span>{{ 'DOCBOX_UPLOAD_FORM_FILE_SELECT_NO_PREVIEW' | translate }}</span>
    }
    <input
        [accept]="allowedMimeTypes.join(',')"
        hidden="true"
        type="file"
        #fileInput
        [attr.aria-label]="'DOCBOX_UPLOAD_FORM_FILE_SELECT' | translate"
    />
</div>
